module.exports = __webpack_public_path__ + "img/alarm-clock.60e88250.svg";